// extracted by mini-css-extract-plugin
export default {"imageWrapper":"cR-z","hovered":"dR-z","hoverImage":"eR-z","mainImage":"fR-z","imageNoBackground":"gR-z","fullSizeImage":"hR-z"};